import { Component, Editor } from "grapesjs";
import { CustomEventTypes } from "../../../globals";
import { getUuidv4 } from "../../../classes/utilities/Misc";

export function loadEditorConfig(editor: Editor)
{
	// clear default toolbar buttons
	editor.Panels.removeButton('options', 'export-template');
	editor.Panels.removeButton('options', 'preview');
	editor.Panels.removeButton('options', 'fullscreen');
	editor.Panels.removeButton('options', 'sw-visibility');

	// more initialisation stuff for after the editor loaded
	editor.on('load', function() 
	{
		// disable native context menu
		const iframeBody = editor.Canvas.getBody();
		if(iframeBody)
		{
			iframeBody.addEventListener('contextmenu', function(e)
			{
				e.preventDefault();
				e.stopPropagation();
			});
		}

		// prevent keyboard events please
		setKeymaps(editor);

		// notify listeners that the editor is ready
		document.dispatchEvent(new CustomEvent(CustomEventTypes.grapesEditorInitialized, { detail: editor }));
	});

	// make sure pasted components have unique ids
	editor.on('component:paste', function(component: Component)
	{
		setIdAttribute(component, true);
	});

	// called when any component is created for any reason - except for `br` components added when editing a text node :|
	editor.on('component:add', function(component: Component) 
	{
		setIdAttribute(component);

		// select the added component
		editor.select(component);
	});

	// force ids on text components whenever they update just to make sure those `br` components get ids
	editor.on('component:update', (component: Component) => 
	{
		if(component.is('text'))
		{
			setIdAttribute(component);
		}
	});	

	// disable the undo manager
	const undoManager = editor.UndoManager;
	undoManager.stop();
	undoManager.clear();
}

function setIdAttribute(comp: Component, replaceExisting: boolean = false) 
{
	// add attribute unless it already exists, or overwrite if replaceExisting is true
	if (replaceExisting || !comp.get('attributes')?.id) 
	{ 
		comp.set('attributes', { ...comp.get('attributes'), 'id': "C" + getUuidv4() });
	}

	// recurse through children
	comp.components().each(child => setIdAttribute(child, replaceExisting));
}

function setKeymaps(editor: Editor)
{
	const keymapManager = editor.Keymaps;

	// prevent default browser behavior by overriding keymaps
	const forbiddenKeyMaps = new Map<string, string>([
		["ctrl+d", "bookmark"],
		["ctrl+e", "google-search"],
		["ctrl+f", "search"],
		["ctrl+g", "goto"],
		["ctrl+h", "history"],
		["ctrl+i", "info"],
		["ctrl+j", "downloads"],
		["ctrl+k", "cut"],
		["ctrl+l", "location"],
		["ctrl+m", "email"],		
		["ctrl+n", "new"],
		["ctrl+o", "open"],
		["ctrl+p", "print"],
		["ctrl+r", "refresh"],
		["ctrl+s", "save"],
		["ctrl+u", "source"],
	]);
	for(const [key, value] of forbiddenKeyMaps)
	{
		keymapManager.add(`custom:${value}-command`, key, () => {}, { prevent: true, });
	}

	// remove default keymaps
	keymapManager.remove(`core:undo`);
	keymapManager.remove(`core:redo`);
	keymapManager.remove(`core:component-delete`);
	keymapManager.remove(`core:copy`);	
	keymapManager.remove(`core:paste`);
}